export default __webpack_public_path__ + "static/media/white-on-transparent.6e428b7f.png";